<template>
    <div class="gallery-block">
        <div v-if="artworks">
            <v-layout wrap row>
                <v-flex v-for="(item, index) of artworks" :key="index" class="mt-3 sale-block">
                    <v-card dark>
                        <v-card-text>                            
                            <p class="title text-uppercase">{{item.name}}</p>
                            <div class="sale-description" v-html="item.description"></div>

                            <div class="mb-3"> Price:
                                <span class="green--text">{{item.price}}</span> 
                            </div>

                            <a data-fancybox="gallery" data-type="image" :href="`/img/gallery/${item.directory}/${item.fileName}.jpg`">
                                <div class="img-thumbnail text-xs-center">
                                    <img :src="`/img/gallery/${item.directory}/${item.fileName}-th.jpg`" alt="art work" class="img-fluid">              
                                </div>
                            </a>
                        </v-card-text>
                    </v-card>                            
                </v-flex>
            </v-layout>
            </div>
        <div v-else>
            <p class="error--text display-1">No artworks for sale at this time!</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['artworks'],
        data: () => ({
            dg_ask: false
        })
    }
</script>

<style>
    .sale-description {
        min-height: 50px;
        padding: 10px;
        margin: 10px;
    }
    .sale-block {
        margin: 10px!important;
        padding: 10px!important;        
        /* border: 1px dotted grey;  */
        text-align:center!important;       
    }
    .gallery-block .img-thumbnail {
        margin-bottom: 5px;
    }
</style>
